import SectionRecord from "models/view-models/section-record";
import { UseSectionPreviewValue } from "organisms/checklist-item-notes/hooks/use-section-preview-value";
import { useMemo, useState } from "react";
import { CollectionUtils } from "utilities/collection-utils";

export const useMultipleSectionPreviews = (
    availableSections: SectionRecord[]
): UseSectionPreviewValue => {
    const [previewingSectionIds, setPreviewingSectionIds] = useState<number[]>(
        []
    );

    const previewSection = (section: SectionRecord): void => {
        setPreviewingSectionIds((previousSections) => {
            if (section.id != null) {
                previousSections.push(section.id);
            }

            return CollectionUtils.distinct(previousSections);
        });
    };

    const removeSectionPreview = (section: SectionRecord): void => {
        setPreviewingSectionIds((previousSectionIds) =>
            previousSectionIds.filter((id) => id !== section.id)
        );
    };

    const toggleSectionPreview = (section: SectionRecord) => {
        if (section.id != null && previewingSectionIds.includes(section.id)) {
            removeSectionPreview(section);
        } else {
            previewSection(section);
        }
    };

    const previewingSections = useMemo(
        () =>
            availableSections.filter(
                (s) => s.id != null && previewingSectionIds.includes(s.id)
            ),
        [availableSections, previewingSectionIds]
    );

    return {
        previewingSections: previewingSections,
        previewSection: previewSection,
        removeSectionPreview: removeSectionPreview,
        toggleSectionPreview: toggleSectionPreview,
    };
};
